export default __webpack_public_path__ + "static/media/zigbee.2a349111.svg";